<div class="card features-faq product-box p-0 m-b-0">
    <plyr style="display: block; width: 100%; height: auto; --plyr-video-background: #fff;"
        [style]="{'--plyr-color-main' : Color}" class="player" [plyrTitle]="Title" [plyrSources]="videoSources" [plyrOptions]="options" (plyrInit)="player = $event" (plyrPlay)="played($event)" (plyrPause)="paused($event)"
        (plyrEnded)="finished($event)" (plyrProgress)="checkingProgress($event)" ></plyr>
</div>